var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.985352,
    width: 34,
    height: 34,
    rx: 4,
    fill: "#2E1834"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02625 16.7162C9.02625 16.3047 8.99321 15.8768 9.04271 15.4653C9.09193 15.0701 9.20724 14.6751 9.28965 14.2966C9.66821 14.4283 10.0798 14.4941 10.409 14.6916C12.3843 15.9756 14.3595 17.276 16.2854 18.6257C16.9767 19.103 17.4541 19.0372 18.1124 18.5762C20.1041 17.1605 22.1617 15.8108 24.2028 14.4611C24.9765 13.9509 25.3715 14.1483 25.3552 15.1032C25.3386 16.3212 25.2892 17.5558 25.1741 18.7575C25.1412 19.0537 24.8778 19.4158 24.6308 19.6133C22.4417 21.1771 20.2194 22.6914 18.0138 24.2222C17.3554 24.6831 16.7463 24.568 16.1208 24.1235C14.2114 22.7901 12.3185 21.4404 10.3432 20.2059C9.3556 19.5969 8.87832 18.8727 9.02654 17.7204C9.0593 17.3746 9.02625 17.0455 9.02625 16.7162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15723 21.5889C10.9678 22.8068 12.5975 23.8934 14.2106 25.0127C14.7868 25.4077 14.7868 25.918 14.2106 26.3294C12.5975 27.4323 10.9515 28.5186 9.15723 29.7201C9.15723 26.9547 9.15723 24.387 9.15723 21.5889Z",
    fill: "#FFCC29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.107 21.6709C25.107 24.4363 25.107 26.889 25.107 29.3086C24.9587 29.3413 24.8765 29.3744 24.8437 29.3578C23.2304 28.3044 21.601 27.2509 20.0042 26.1481C19.8397 26.0328 19.7905 25.3744 19.9219 25.2757C21.5517 24.0905 23.214 22.9548 25.107 21.6709Z",
    fill: "#FFCC29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0319 13.1825C20.7533 10.7176 18.9404 6 16.7106 6C15.6572 6 14.6114 7.09337 13.7659 9.07844C13.2071 10.3909 12.7925 11.9821 12.6806 13.1809C12.3862 13.2484 12.167 13.5108 12.167 13.8251C12.167 14.1906 12.4632 14.4868 12.8296 14.4868C13.1951 14.4868 13.4913 14.1906 13.4913 13.8251C13.4913 13.5464 13.3189 13.3086 13.0752 13.211C13.1829 12.0552 13.5862 10.5114 14.1304 9.2337C14.5818 8.17366 15.5171 6.39586 16.7106 6.39586C18.5352 6.39586 20.3732 10.7224 20.6397 13.2081C20.3915 13.3034 20.2152 13.5435 20.2152 13.8251C20.2152 14.1906 20.5112 14.4868 20.8769 14.4868C21.2433 14.4868 21.5394 14.1906 21.5394 13.8251C21.5394 13.5129 21.323 13.2519 21.0318 13.1823L21.0319 13.1825Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlogo);
export default __webpack_public_path__ + "static/media/slogo.af4c1b9cb43c8f5a314355cee38393f2.svg";
export { ForwardRef as ReactComponent };